import React from 'react';
const IconFormXCircle = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.0701 4.93C15.1601 1.02 8.83012 1.02 4.92012 4.93C1.02012 8.83 1.02012 15.17 4.92012 19.07C8.83012 22.98 15.1601 22.98 19.0701 19.07C22.9801 15.17 22.9801 8.83 19.0701 4.93ZM16.2401 14.74L14.8301 16.15L12.0001 13.33L9.17012 16.16L7.76012 14.75L10.5901 11.92L7.76012 9.08L9.17012 7.67L12.0001 10.5L14.8301 7.67L16.2401 9.08L13.4101 11.91L16.2401 14.74Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconFormXCircle;